export default "__VITE_ASSET__Dbpmqaho__"